module.exports = __webpack_public_path__ + "static/media/how-it-works.c03caac.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/how-it-works.mp4
// module id = p488
// module chunks = 1